
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  updateOrderStatus,
  updateOrderPayStatus,
  OrderParamsDTO,
  OrderListDto,
  getOrderNodeList,
  getOrderInfoListApp
} from "@/api/order";
import { Getter } from "vuex-class";
import OrderListItem from "../template/OrderListItem.vue";
import MoreFilter from "../template/MoreFilter.vue";

@Component({
  name: "SalesOrder",
  components: {
    OrderListItem,
    MoreFilter
  },
  filters: {
    filterActive(active: number) {
      const typeMap = {
        0: "近60天",
        1: "近7天",
        2: "本月",
        3: "上月",
        4: "本季度",
        5: "上季度",
        6: "本年",
        7: "去年",
        8: "自定义"
      };
      return typeMap[active as keyof typeof typeMap] || "时间筛选";
    }
  }
})
export default class PurchaseOrder extends Vue {
  @Getter companyId!: string;
  showSelect = false;
  orderStatus = 0;
  // orderStatusList（1待订单审核 2待出库确认 3待发货确认 4待收货确认 5已完成 6已作废）不传默认全部订单
  orderStatusOptions = [
    { text: "全部订单", value: 0, orderStatusList: [] },
    { text: "待订单审核", value: 1, orderStatusList: [1] },
    { text: "待出库确认", value: 2, orderStatusList: [2] },
    { text: "待发货确认", value: 3, orderStatusList: [3] },
    { text: "待收货确认", value: 4, orderStatusList: [4] },
    { text: "已完成", value: 5, orderStatusList: [5] },
    { text: "已作废", value: 6, orderStatusList: [6] }
  ];
  result = [];
  operation = 4;
  operationList = [];
  loading = false;
  finished = false;
  refreshing = false;

  // 查询参数
  params: OrderParamsDTO = {
    companyId: "",
    startTime: "",
    endTime: "",
    pageIndex: 1,
    pageSize: 10,
    orderType: "",
    payStatus: "",
    orderStatus: []
  };
  orderList: OrderListDto[] = [];
  totalRecords = 0;
  // 时间筛选
  timeActive = "0";
  orderToggle = 0; // 订货单0，退货单1
  $refs!: {
    moreFilter: MoreFilter;
    checkboxGroup
  };
  isSelect = false;
  checked = false

  @Watch("orderStatus")
  onOrderStatusChange(newVal, oldVal) {
    let obj = this.orderStatusOptions.find((item) => {
      return item.value === newVal;
    });
    this.params.orderStatus = obj.orderStatusList;
    // 刷新列表数据
    this.params.pageIndex = 1;
    this.getOrderList();
  }

  activated() {
    // 解决keep-alive 返回页面时,页面还处于编辑状态的异常问题i
    this.isSelect = false
    this.showSelect = false;
    this.checked = false
    this.result = []
    // 订单状态改变，刷新订单列表
    if (window.sessionStorage.getItem("isRefresh") === "1") {
      this.params.pageIndex = 1;
      this.getOrderList();
      this.getNodeList();
      window.sessionStorage.setItem("isRefresh", "0");
    }
  }

  created() {
    this.params.companyId = this.companyId;
    // 初始化获取数据
    this.getOrderList();
    this.getNodeList();
  }

  mounted() {
    this.$eventBus.$on("orderManage", (res: boolean) => {
      this.showSelect = res;
    });

    // 监听时间筛选
    this.$eventBus.$on("timeFilter", (res) => {
      this.timeActive = res.timeActive;
      this.params.startTime = res.startTime;
      this.params.endTime = res.endTime;
      // 刷新列表数据
      this.params.pageIndex = 1;
      this.getOrderList();
    });

    // 监听更多筛选
    this.$eventBus.$on("moreFilter", (res) => {
      this.params.orderType = res.orderType;
      this.params.payStatus = res.status;
      this.timeActive = res.timeActive;
      this.params.startTime = res.startTime;
      this.params.endTime = res.endTime;
      // 刷新列表数据
      this.params.pageIndex = 1;
      this.getOrderList();
    });

    // 监听详情页删除订单返回
    this.$eventBus.$on("orderDetail", () => {
      // 刷新列表数据
      this.params.pageIndex = 1;
      this.getOrderList();
    });
  }

  destroyed() {
    // 页面销毁，关闭监听事件
    this.$eventBus.$off("orderManage");
    this.$eventBus.$off("timeFilter");
    this.$eventBus.$off("moreFilter");
    this.$eventBus.$off("orderDetail");
  }

  @Watch("showSelect")
  changeSelect(val: boolean) {
    if (val) {
      this.result = [];
      this.checked = false
      this.allCheck()
      this.$nextTick(() => {
        let btn = document.getElementsByClassName(
          "btn-operation"
        )[0] as HTMLElement;
        let menu = document.getElementsByClassName(
          "van-dropdown-menu__title"
        )[1] as HTMLElement;
        btn.style.width = menu.offsetWidth + 4 + "px";
        btn.style.height = menu.offsetHeight + "px";
        btn.style.lineHeight = menu.offsetHeight + "px";
        btn.style.top = "0";
      });
    }
  }

  manage() {
    this.isSelect = !this.isSelect;
    this.$eventBus.$emit("orderManage", this.isSelect);
  }

  checkCheckAll () {
    this.checked = (this.orderList.length === this.result.length)
  }

  /**
   * @description: 全选切换
   * @param {*}
   * @return {*}
   */
  allCheck() {
    this.$refs.checkboxGroup.toggleAll(this.checked);
  }

  // 获取订货/退货处理流程,根据订货处理流程设置设置批量操作按钮
  getNodeList() {
    const param = {
      companyId: this.companyId,
      orderType: 1, // 1:订货单 2:退货单
      isValid: "Y" // Y:有效 N:无效
    };
    getOrderNodeList(param, false).then((res) => {
      const nodeList = res.data || [];
      // this.operationList = nodeList.filter(item => [1, 2, 3].includes(item.orderNodeId)).map(item => {
      //   return {
      //     text: item.nodeName,
      //     value: item.orderNodeId
      //   }
      // })
      this.operationList.push({
        text: "收货确认",
        value: 4,
        limit: "updateOrderStatus4"
      }); // limit :权限控制字段
    });
  }

  /**
   * @description: 上拉加载更多
   * @param {*}
   * @return {*}
   */
  onLoad() {
    this.params.pageIndex++;
    this.loading = true;
    getOrderInfoListApp(this.params)
      .then((res) => {
        this.orderList = this.orderList.concat(res.data.records);
        // 加载状态结束
        this.loading = false;
        if (this.orderList.length >= res.data.totalRecords) {
          this.finished = true;
        }
      })
      .finally(() => {
        this.refreshing = false;
      });
  }

  /**
   * @description: 下拉刷新
   * @param {*}
   * @return {*}
   */
  onRefresh() {
    this.params.pageIndex = 1;
    this.refreshing = true;
    this.getOrderList();
  }

  /**
   * @description: 更多筛选
   * @param {*}
   * @return {*}
   */
  toMoreFilter() {
    (this.$refs.moreFilter as any).show({
      pageType: "1",
      orderType: this.params.orderType as string,
      status: this.params.payStatus as string,
      timeActive: String(this.timeActive),
      startTime: this.params.startTime,
      endTime: this.params.endTime
    });
  }

  // 转换操作按钮显示
  replaceOper(val: any) {
    let data = this.operationList.filter((item) => {
      return item.value === val;
    });
    return data[0].text;
  }

  /**
   * @description: 获取订货单列表
   * @param {*}
   * @return {*}
   */
  getOrderList() {
    this.totalRecords = 0;
    this.params.pageIndex = 1;
    getOrderInfoListApp(this.params)
      .then((res) => {
        this.orderList = res.data.records || [];
        this.totalRecords = res.data.totalRecords;

        if (this.orderList.length >= this.totalRecords) {
          this.finished = true;
        } else {
          this.finished = false;
        }
      })
      .finally(() => {
        this.refreshing = false;
        this.showSelect = false;
        this.isSelect = false;
        this.$eventBus.$emit("orderManage", this.isSelect);
      });
  }

  /**
   * @description: 批量操作方法
   * @param {*操作类型：1：订单审核2：出库确认3：发货确认6：作废7：删除8：付款确认} operateType
   * @return {*}
   */
  handleBatchOperation(operateType) {
    if (!this.$action(`updateOrderStatus${operateType}`)) {
      return false;
    }
    if (this.result.length === 0) return;
    let operateTypeText =
      operateType === 7 ? "删除" : this.replaceOper(operateType);
    this.$dialog
      .confirm({
        title: "温馨提示",
        message: `确定“${operateTypeText}”所选订单？`
      })
      .then(() => {
        let orderIdList = this.result.map((orderId) => {
          let obj = this.orderList.find((item) => {
            return item.orderId === orderId;
          });
          return {
            currRouteId: obj.currRouteId,
            orderId: orderId,
            orderStatus: obj.orderStatus
          };
        });
        let isNext = orderIdList.find((item) => item.orderStatus == 4);
        if (!isNext) {
          this.$toast("无待收货确认的订单");
          return;
        }
        let params = {
          companyId: this.companyId,
          operateType,
          orderIdList
        };
        // 修改订货单状态方法
        this.updateOrderStatus(params, operateTypeText);
      })
      .catch(() => {
        console.log("取消");
      });
  }

  updateStatus(params, tips, operateType) {
    if (operateType !== 8) {
      this.updateOrderStatus(params, tips);
    } else {
      this.updateOrderPayStatus(params, tips);
    }
  }

  /**
   * @description: 修改订货单状态方法
   * @param {*请求参数} params
   * @param {*提示} tips
   * @return {*}
   */
  updateOrderPayStatus(params, tips) {
    updateOrderPayStatus(params).then((res) => {
      this.$toast.success({
        message: `${tips}成功`,
        duration: 1000,
        onClose: () => {
          // 刷新数据
          this.params.pageIndex = 1;
          this.getOrderList();
        }
      });
    });
  }

  /**
   * @description: 修改订货单状态方法
   * @param {*请求参数} params
   * @param {*提示} tips
   * @return {*}
   */
  updateOrderStatus(params, tips) {
    updateOrderStatus(params).then((res) => {
      this.$toast.success({
        message: `${tips}成功`,
        duration: 1000,
        onClose: () => {
          // 刷新数据
          this.params.pageIndex = 1;
          this.getOrderList();
        }
      });
    });
  }

  /**
   * 当点击底部导航，页面切换时，原生调用h5接口，重置管理按钮状态
   */
  refreshPage() {
    this.$bridge.registerHandler(
      "refreshPage",
      (data: string, responseCallback) => {
        this.isSelect = false;
        this.$eventBus.$emit("orderManage", this.isSelect);
        responseCallback();
      }
    );
  }
}
